jQuery(document).ready(function($) {
    // Sticky weight loss CTA
    /* watcher for fixed element */
    
    const wrappers = document.querySelectorAll('.tfcStickySection');
    if (wrappers.length) {
      const observer = new IntersectionObserver(
          (entries) => {
              const anyVisible = entries.some(entry => entry.isIntersecting);
              $('.tfcStickyBarElement').toggleClass('is-visible', anyVisible);
          },
          {
              threshold: 0.01,
              rootMargin: '0px 0px -10px 0px'
          }
      );
      
      wrappers.forEach(wrapper => observer.observe(wrapper));
    } 
});
